var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgExcel = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15V17C5 17.5 5.4 18 6 18H17C17.6 18 18 17.5 18 17V3C18 2.5 17.6 2 17 2H6C5.4 2 5 2.5 5 3V5H3C2.4 5 2 5.5 2 6V14C2 14.5 2.4 15 3 15H5ZM12 11H17V14H12V11ZM12 10V7H17V10H12ZM6 15H11V17H6V15ZM12 17V15H17V17H12ZM17 6H12V3H17V6ZM6 3H11V5H6V3ZM8.1 13.2L7 11.2L5.9 13.3H3.9L5.9 10L4 6.8H6L7 8.8L8.1 6.8H10L8.1 10L10.1 13.3H8.1V13.2Z",
    fill: "#03787C"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExcel);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Excel.bc32b3ac4825f4230aa50a7830d8fe1d.svg";